import React, { useRef } from 'react';
import './index.css';

import ImgBottomLabel from '@/src/components/HomePage/ImgBottomLabel';
import { attachments } from '@/src/components/HomePage/ContentItems';
import GroupMealTag from '@/src/components/HomePage/GroupMealTag';
import { DishDataType, PuzzleComponent } from '../interface';

const WMRouter = Mach.requireModule('Router');
type DishIProps = {
  data: DishDataType;
  index: number;
  onClick?: (data: DishDataType, index: number) => void;
}
function ShopDish(props: DishIProps) {
  const pictureUrl = props?.data?.pictures?.[0]?.url;
  const imgBottomLabel = props?.data?.imgBottomLabel;
  const imgTopRightContent = props?.data?.imgTopRightContent;
  const dishIndex = props?.index;
  const content = props?.data?.content || [];
  function getCustomContentItemStyle({ type, data }: {type: string; data: any;}) {
    if (type === 'spuName') {
      return {
        maxLines: 2,
      };
    }
    if (type === 'spuPrice') {
      return {
        maxLines: 1,
        customProperty: {
          // height: 18,
          // marginTop: 6
        }
      };
    }
    return {
      maxLines: 1
    };
  }
  return (
    <view className="shop-card-dish" style={dishIndex ? undefined : { marginLeft: 12 }} onClick={() => props.onClick && props.onClick(props.data, dishIndex)}>
      <view className="shop-card-dish-picture-area">
        <image
          className="shop-card-dish-picture"
          style={Mach.env.isAndroid ? { borderRadius: 9 } : undefined}
          resizeMode="aspectFill"
          placeholder="assets://placeholder/icon_placeholder_4:3.png"
          src={
            // eslint-disable-next-line
                    pictureUrl
              ? pictureUrl
              : 'assets://placeholder/icon_placeholder_4:3.png'
          }
          error="assets://placeholder/icon_placeholder_4:3.png"
        />
        {imgBottomLabel ? <ImgBottomLabel imgBottomLabel={imgBottomLabel} /> : null}
        {imgTopRightContent && <GroupMealTag data={imgTopRightContent} />}
      </view>
      <view className="shop-card-dish-content-area">
        { // eslint-disable-next-line
                content.map((warp, line) => <view className={'shop-card-dish-content-line'}>
            { // eslint-disable-next-line
                        warp.map((item, index) => {
                const attachmentData = attachments[item?.type];
                const customStyles = getCustomContentItemStyle({
                  type: item.type,
                  data: item.data
                });
                const lastAttachmentData = attachments[warp?.[index + 1]?.type];
                if (attachmentData) {
                  return (
                    <attachmentData.attachment
                      key={`item.type_${line}_${index}`}
                      data={item?.data}
                      line={line}
                      index={index}
                      itemKey={item?.type}
                      hasLastItem={lastAttachmentData !== undefined}
                      style={customStyles}
                    />
                  );
                }
                return null;
              })
            }
          </view>)
        }
      </view>
    </view>
  );
}

type DishListIProps = {
  subCards: DishDataType[];
  onClick?: (data: DishDataType, index: number) => void;
  onScrollEnd?: (x: number) => void;
}

export default function (props: DishListIProps) {
  const productInfoList = props?.subCards || [];
  const listWidthRef = useRef(0);
  // const hasMvSpuIdListRef = useRef([])

  function handleDishClick(item, index) {
    const scheme = item?.pictures?.[0]?.scheme || item?.scheme;
    props.onClick && props.onClick(item, index);
    if (!scheme) return;
    WMRouter.navigateTo(scheme, null, (result: any) => {
      if (!result.success) {
        // @ts-ignore
      }
    });
  }

  if (!(productInfoList || []).length) return null;
  return (
    <view
      className="shop-card-dish-list" onLayout={(frame) => {
        listWidthRef.current = frame?.detail?.width;
      }}
    >
      <scroller
        showScrollIndicator={false} onScrollEnd={(offset) => {
          // ts-ignore
          props.onScrollEnd && props.onScrollEnd(offset?.x);
        }}
      >
        <content>
          {(productInfoList || []).map((item, index) => (
            <ShopDish
              key={index}
              data={item}
              index={index}
              onClick={handleDishClick}
            />
          ))}
        </content>
      </scroller>
    </view>
  );
}
